import React, {Component, Fragment} from 'react';
import marketStyle from '../css/markets.css';
import OddsCard from './oddsCard';
import BetBothCard from './betBothCard';

class CorrectScore extends Component {
    render() {
        let store = this.props.store;
        let matchdayMarkets = this.props.matchdayMarkets;
        let correctScoreMarkets = [];
        let storeData = store.getState();
        let useBetBothMatchday = storeData.vpp.useBetBothMatchday;

        matchdayMarkets.map((eventMarket) => {
            let winMarket = eventMarket.market.slice(0, 12);
            let drawMarket = eventMarket.market.slice(12, 16);
            let looseMarket = eventMarket.market.slice(16, 28);
            for (let i = 0; i < 12; i++) {
                let drawMarketTemp = '';
                if (drawMarket[i]) {
                    drawMarketTemp = (<div className={`${marketStyle.scoreGroupSmall}`}>
                        <div className={`${marketStyle.marketLabelSmall} ${marketStyle.marketLabel}`}>
                            <span>{drawMarket[i].selection}</span>
                        </div>
                        <div className={marketStyle.oddsContainerSmall}>
                            <OddsCard store={store} market={drawMarket[i]} event={eventMarket.event}/>
                        </div>
                    </div>);
                } else {
                    drawMarketTemp = (<div className={`${marketStyle.scoreGroupSmall}`}>
                        {useBetBothMatchday.toLowerCase().includes('all') || useBetBothMatchday.includes(winMarket[i].selection.split('-')[0] + '_' + winMarket[i].selection.split('-')[1]) ?
                            <BetBothCard store={store} markets={[winMarket[i], looseMarket[i]]}
                                         event={eventMarket.event} id={i}/> :
                            <OddsCard store={store} market={'empty'} event={eventMarket.event}/>}
                    </div>);
                }
                correctScoreMarkets.push(
                    <Fragment key={i}>
                        <div className={`${marketStyle.scoreGroupSmall}`}>
                            <div className={`${marketStyle.marketLabelSmall} ${marketStyle.marketLabel}`}>
                                <span>{winMarket[i].selection}</span>
                            </div>
                            <div className={marketStyle.oddsContainerSmall}>
                                <OddsCard store={store} market={winMarket[i]} event={eventMarket.event}/>
                            </div>
                        </div>
                        {drawMarketTemp}
                        <div className={`${marketStyle.scoreGroupSmall}`}>
                            <div className={`${marketStyle.marketLabelSmall} ${marketStyle.marketLabel}`}>
                                <span>{looseMarket[i].selection}</span>
                            </div>
                            <div className={marketStyle.oddsContainerSmall}>
                                <OddsCard store={store} market={looseMarket[i]} event={eventMarket.event}/>
                            </div>
                        </div>
                    </Fragment>
                );
            }

        });
        return (
            <div className={`${marketStyle.marketGroup} ${marketStyle.marketAlignFlex}`}>{correctScoreMarkets}</div>);
    }
}

export default CorrectScore;



// WEBPACK FOOTER //
// ./src/ui-modules/sports-book/modules/matchday/components/correctScore.js